import Clickable from 'components/Common/Clickable'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import CaptionTextBlock from 'LuxKit/TextBlocks/CaptionTextBlock'
import React, { ComponentProps, MouseEventHandler, PropsWithChildren, useCallback } from 'react'

type InheritedCaptionTextBlockProps = Pick<ComponentProps<typeof CaptionTextBlock>, 'startIcon' | 'strikeThrough'>

interface Props extends PropsWithChildren, InheritedCaptionTextBlockProps {
  /**
   * Won't bubble/propagate.
  */
  onInfoIconClick?: MouseEventHandler<HTMLButtonElement>
  className?: string
}

function PriceRowPriceCaption(props: Props) {
  const {
    children,
    onInfoIconClick,
    strikeThrough,
    className,
    startIcon,
  } = props

  const handleInfoIconClick = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()
    event.stopPropagation()
    onInfoIconClick?.(event)
  }, [onInfoIconClick])

  return <CaptionTextBlock
    className={className}
    variant="large"
    colour="neutral-two"
    weight="normal"
    format="propercase"
    startIcon={startIcon}
    endIcon={onInfoIconClick && <Clickable onClick={handleInfoIconClick}><LineInfoCircleIcon /></Clickable>}
    strikeThrough={strikeThrough}
  >
    {children}
  </CaptionTextBlock>
}

export default PriceRowPriceCaption
